/**
 * Calendar-date serialization for API payloads.
 *
 * `@fm/api` is the base layer and depends on no other workspace package, so it
 * carries its own copy of this rather than importing `@fm/ui`'s. The two must
 * agree: a calendar date is serialized from its OWN day, never by rendering an
 * instant in some timezone.
 */

/**
 * Convert a Date to "YYYY-MM-DD" using its own calendar day.
 *
 * Never use `.toISOString()` for this. That renders the instant in UTC, so a
 * Date at local midnight anywhere east of Greenwich reports the previous day —
 * a customer in London quoting September 6 sent September 5.
 */
export function toDateString(value: Date): string {
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}
